import { type Flags, flagDefaults } from "@jslib/shared/flags";

const FLAG_OVERRIDE_PARAM_NAME = "_flagOverride";

/**
 * getOverriddenFlags allows `_flagOverride=FLAG-NAME:VALUE` query string
 * params. Multiple `_flagOverride` params can be used. Values of "true" and
 * "false" are converted to booleans. Everything else stays as a string.
 *
 * The function arguments should only be passed for unit testing.
 */
export const getOverriddenFlags = (
  _defaults = flagDefaults,
  _href = window.location.href,
): Partial<Flags> => {
  const url = new URL(_href);
  const overrideQsps = url.searchParams.getAll(FLAG_OVERRIDE_PARAM_NAME);

  const overrides = overrideQsps.reduce((overrideCollector, qsp) => {
    const [key, val] = qsp.split(":");

    // skip if we don't have a key, or value, or if the key is not in our
    // defaults object.
    if (!key || !val || !Object.keys(_defaults).includes(key)) {
      return overrideCollector;
    }

    // Covert the literal strings "true" and "false" to booleans.
    // Don't touch anything else.
    const normalizedVal = val === "true" || val === "false" ? JSON.parse(val) : val;

    return { ...overrideCollector, [key]: normalizedVal };
  }, {});

  return overrides;
};
